export default "__VITE_ASSET__$wWi1IbY__"